export default __webpack_public_path__ + "static/output-5a7b8d37ebd6f7a570cdcd786b0c505a.webm";